module.exports = __webpack_public_path__ + "img/h2.decb269f.png";